import TermsWebScreen from './terms.web';

export default TermsWebScreen;
